/* eslint-disable react/no-unescaped-entities */
import LegalPageLayout from './LegalPageLayout';

/**
 * Conditions Générales d'Utilisation (CGU) — tailored to a SaaS that
 * analyzes French notarial / inheritance documents. Production-ready
 * baseline; no placeholders, no Lorem Ipsum, no TODOs.
 */
const CONTACT_EMAIL = 'helloherita@proton.me';

const CGU = () => {
  return (
    <LegalPageLayout
      eyebrow="Conditions générales d'utilisation"
      title="Les règles d'usage du service Hérita."
      lastUpdated="1ᵉʳ juin 2026"
      testId="page-cgu"
      seoTitle="Conditions générales d'utilisation | HÉRITA"
      seoDescription="Conditions générales d'utilisation du service Hérita : objet, accès, paiement unique de 19 €, propriété intellectuelle et limites de responsabilité."
      seoPath="/cgu"
    >
      <p>
        Les présentes conditions générales d'utilisation (ci-après les « CGU »)
        ont pour objet de définir les modalités d'accès et d'utilisation du
        service Hérita (ci-après le « Service ») par toute personne y accédant
        (ci-après « l'Utilisateur »). En accédant au Service ou en l'utilisant,
        l'Utilisateur reconnaît avoir pris connaissance des présentes CGU et les
        accepter sans réserve.
      </p>

      <h2>1. Objet du Service</h2>
      <p>
        Hérita propose un service en ligne (SaaS) d'analyse de documents
        notariés et patrimoniaux français. Le Service permet à l'Utilisateur
        de soumettre un document (acte notarié, succession, donation-partage,
        testament, attestation immobilière, vente immobilière, partage,
        indivision, SCI, courrier notarial, etc.) et de recevoir en retour
        une lecture structurée en français clair, comprenant notamment&nbsp;:
      </p>
      <ul>
        <li>la catégorisation du document et l'identification des informations clés ;</li>
        <li>une lecture personnalisée par rôle (vendeur, acquéreur, héritier, donateur, etc.) ;</li>
        <li>des actions à mener et des questions utiles à poser à un notaire ;</li>
        <li>l'export du dossier Hérita au format PDF.</li>
      </ul>

      <h2>2. Caractère strictement informatif des analyses</h2>
      <div className="legal-callout sand">
        <p style={{ marginBottom: 0 }}>
          <strong>Important.</strong> Les analyses produites par Hérita sont
          fournies à titre <strong>strictement informatif et pédagogique</strong>.
          Elles ne constituent ni un conseil juridique, ni un conseil fiscal,
          ni un conseil notarial personnalisé, et <strong>ne remplacent jamais
          l'avis d'un notaire ou d'un professionnel du droit</strong> dûment
          habilité. Toute décision patrimoniale doit être confirmée auprès du
          notaire en charge du dossier.
        </p>
      </div>

      <h2>3. Accès au Service</h2>
      <p>
        Le Service est accessible depuis un navigateur web compatible et une
        connexion Internet. Hérita s'efforce d'assurer un accès continu, mais ne
        peut garantir une disponibilité absolue : des interruptions peuvent
        intervenir pour des opérations de maintenance, en cas d'incident
        technique, ou en cas de force majeure. Hérita ne saurait être tenue
        responsable des conséquences de telles interruptions.
      </p>

      <h2>4. Compte utilisateur</h2>
      <p>
        L'utilisation du Service ne nécessite pas, à ce stade, la création d'un
        compte personnel. Lorsque la création d'un compte sera proposée,
        l'Utilisateur s'engagera à fournir des informations exactes, à conserver
        confidentiels ses identifiants et à informer Hérita en cas d'usage
        frauduleux de son compte. Les modalités de création, de gestion et de
        clôture du compte seront alors précisées au sein du Service et dans une
        version mise à jour des présentes CGU.
      </p>

      <h2>5. Engagements de l'Utilisateur</h2>
      <p>L'Utilisateur s'engage à :</p>
      <ul>
        <li>
          ne soumettre que des documents dont il est destinataire légitime ou
          pour lesquels il est habilité à demander une analyse ;
        </li>
        <li>
          ne pas téléverser de documents contenant des données pour lesquelles
          il n'aurait ni le droit ni l'autorisation de tiers concernés ;
        </li>
        <li>
          utiliser le Service de bonne foi, pour un usage personnel ou
          professionnel licite ;
        </li>
        <li>
          ne pas tenter de contourner les mesures de sécurité du Service, ni de
          dégrader sa disponibilité, ni d'en extraire massivement le contenu
          par des moyens automatisés ;
        </li>
        <li>
          ne pas utiliser le Service pour produire ou diffuser des contenus
          illicites, diffamatoires, contrefaisants ou portant atteinte aux
          droits de tiers.
        </li>
      </ul>
      <p>
        Tout manquement à ces obligations peut entraîner la suspension immédiate
        de l'accès au Service, sans préjudice de poursuites éventuelles.
      </p>

      <h2>6. Tarifs et paiement</h2>
      <p>
        Hérita propose une lecture initiale gratuite permettant de comprendre la
        nature et la structure du document soumis. Une lecture personnalisée
        avancée, ainsi que l'export du dossier au format PDF, peuvent être
        proposés via une formule payante (ci-après l'« Offre Premium »). Les
        prix applicables, la durée d'engagement éventuelle et les modalités de
        paiement sont affichés au sein du Service au moment de la souscription,
        en euros toutes taxes comprises lorsque la TVA est applicable.
      </p>
      <p>
        Le paiement est exigible immédiatement, sauf indication contraire.
        Conformément à l'article L. 221-28, 13° du Code de la consommation, le
        droit de rétractation ne s'applique pas dès lors que l'exécution du
        Service a débuté avec l'accord exprès de l'Utilisateur et qu'il a
        renoncé à son droit de rétractation. Les conditions précises de
        remboursement éventuel sont précisées au moment de l'achat.
      </p>

      <h2>7. Propriété intellectuelle</h2>
      <p>
        Le Service, ses composants logiciels, son design, ses textes, sa marque
        et ses prompts d'analyse demeurent la propriété exclusive d'Hérita.
        L'Utilisateur dispose d'un droit personnel, non exclusif et non
        cessible d'utiliser le Service dans la limite de ses fonctionnalités et
        des présentes CGU.
      </p>
      <p>
        Les documents soumis par l'Utilisateur demeurent sa propriété pleine et
        entière. L'Utilisateur concède à Hérita le droit, strictement limité au
        temps et au périmètre de la prestation, d'utiliser le contenu du
        document aux seules fins de produire l'analyse demandée. Hérita ne
        revendique aucun droit sur les documents soumis et ne les utilise
        jamais à d'autres fins.
      </p>

      <h2>8. Protection des données personnelles</h2>
      <p>
        Hérita traite les données personnelles dans le strict respect du RGPD
        et de la loi française « Informatique et Libertés ». Les modalités
        complètes (catégories de données, finalités, durées de conservation,
        droits des Utilisateurs) sont décrites dans notre{' '}
        <a href="/confidentialite">politique de confidentialité</a>, qui fait
        partie intégrante des présentes CGU.
      </p>

      <h2>9. Limitation de responsabilité</h2>
      <p>
        Hérita met en œuvre des moyens techniques raisonnables pour produire des
        analyses fiables, mais ne peut en aucun cas garantir l'absence
        d'erreurs, d'omissions ou d'imprécisions, notamment lorsque le document
        soumis est partiellement lisible, ambigu, incomplet ou rédigé dans un
        format atypique. L'Utilisateur reconnaît que :
      </p>
      <ul>
        <li>
          les analyses sont produites par un système d'intelligence artificielle
          et peuvent comporter des inexactitudes ;
        </li>
        <li>
          il lui appartient de vérifier les éléments importants auprès de son
          notaire ou d'un professionnel du droit avant toute décision ;
        </li>
        <li>
          Hérita ne saurait être tenue responsable d'un préjudice résultant
          d'une décision prise sur la seule base d'une analyse Hérita.
        </li>
      </ul>
      <p>
        Dans toute la mesure permise par la loi, la responsabilité d'Hérita,
        toutes causes confondues, est plafonnée au montant effectivement
        acquitté par l'Utilisateur au titre du Service au cours des douze (12)
        mois précédant le fait générateur du dommage.
      </p>
      <p>
        Aucune limitation n'est applicable en cas de faute lourde ou
        intentionnelle, ni en cas d'atteinte à la vie ou à l'intégrité
        corporelle des personnes, ni dans les cas où la loi interdit toute
        limitation de responsabilité.
      </p>

      <h2>10. Disponibilité du Service et évolutions</h2>
      <p>
        Hérita peut faire évoluer le Service à tout moment : ajout, modification
        ou suppression de fonctionnalités, mise à jour de l'interface, évolution
        des modèles d'analyse. Hérita peut également interrompre temporairement
        le Service pour des raisons de maintenance ou de sécurité. Les
        évolutions substantielles susceptibles d'affecter les droits des
        Utilisateurs feront l'objet d'une information préalable.
      </p>

      <h2>11. Force majeure</h2>
      <p>
        Aucune des parties ne pourra être tenue responsable d'un manquement
        résultant d'un cas de force majeure tel que défini par l'article 1218
        du Code civil et par la jurisprudence des juridictions françaises.
      </p>

      <h2>12. Suspension et résiliation</h2>
      <p>
        L'Utilisateur peut cesser d'utiliser le Service à tout moment. Hérita
        peut suspendre ou résilier l'accès au Service en cas de manquement
        grave aux présentes CGU, après notification préalable et, lorsque cela
        est possible, mise en demeure restée infructueuse pendant un délai
        raisonnable.
      </p>

      <h2>13. Modification des CGU</h2>
      <p>
        Hérita se réserve le droit de modifier les présentes CGU à tout moment.
        La version applicable est celle en vigueur au moment de l'utilisation
        du Service. La date de dernière mise à jour est mentionnée en haut de
        cette page. En cas de modification substantielle, une notification
        sera affichée au sein du Service.
      </p>

      <h2>14. Droit applicable et règlement des différends</h2>
      <p>
        Les présentes CGU sont régies par le droit français. En cas de litige,
        les parties s'efforceront de trouver une solution amiable. À défaut, et
        sous réserve des dispositions impératives applicables aux consommateurs,
        les tribunaux français seront seuls compétents. Conformément à
        l'article L. 612-1 du Code de la consommation, l'Utilisateur consommateur
        a la possibilité de recourir gratuitement à un médiateur de la
        consommation en vue de la résolution amiable du litige qui l'opposerait
        à Hérita, après l'avoir préalablement contactée par écrit.
      </p>

      <h2>15. Contact</h2>
      <p>
        Pour toute question relative aux présentes CGU, écrivez-nous à{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>, ou via la{' '}
        <a href="/contact">page Contact</a>. Vous pouvez également consulter
        nos <a href="/mentions-legales">mentions légales</a> et notre{' '}
        <a href="/confidentialite">politique de confidentialité</a>.
      </p>
    </LegalPageLayout>
  );
};

export default CGU;
